import { render } from "./FilterContainer.vue?vue&type=template&id=45fc83ac"
import script from "./FilterContainer.vue?vue&type=script&lang=js"
export * from "./FilterContainer.vue?vue&type=script&lang=js"

import "./FilterContainer.vue?vue&type=style&index=0&id=45fc83ac&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__